export const SHOULD_SHOW_FULLSCREEN = 'RAYCHAT_ALWAYS_FULLSCREEN'
export const WIDGET_LANG_KEY = 'RAYCHAT_WIDGET_LANG'
